import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addDesignationHr = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Designation',
    body
  );
  return data;
});
export const updateDesignationHr = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Designation/${id}`,
    body
  );
  return data;
});

export const getDesignationHr = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Designation'
  );
  return data;
});
export const deleteDesignationHr = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Designation/${record}`
  );
  return data;
});
export const getDesignationHrDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Designation/${id}`
  );
  return data;
});
